export default __webpack_public_path__ + "static/media/Oral Presentation Room 1.5f051b2b.JPG";